import * as React from 'react';

import { useTranslation } from 'react-i18next';

export const OfferCom2 = () => {
	const { i18n } = useTranslation();
	if (i18n.language === 'ru') {
		return (
			<>
				<p>
					VIP Pass — это ваше уникальное предложение от Vip House по получению призов и подарков на основе вашего
					игрового прогресса.
				</p>
				<p>
					Выполняйте квесты и зарабатывайте XP, которые можно обменять на FreeSpins, FreeBet, SportBonus, лимитированный
					мерч сайта, гаджеты и игровые предметы.
				</p>
				<p>
					Основные положения определяют порядок, сроки и условия проведения Предложения, требования к участию,
					количество Призов, а также сроки, порядок и место их получения.
				</p>
				<p>
					<strong>Основные термины:</strong>
				</p>
				<p>
					<strong>Предложение – </strong>промо-кампания «VIP Pass», организованная Организатором;
				</p>
				<p>
					<strong>Организатор – </strong>(далее — Сайт) ресурс Vip House и ответственные лица, действующие от его имени;
				</p>
				<p>
					<strong>Игровой аккаунт – </strong>личный кабинет Участника, зарегистрированный у Организатора;
				</p>
				<p>
					<strong>Игровой идентификатор – </strong>номер Игрового аккаунта Участника, зарегистрированного у
					Организатора; Основные правила — действующие правила Организатора, правила заключения пари и ставок,
					опубликованные на Сайте.
				</p>
				<p>
					<strong>Период проведения Акции – </strong>срок, установленный Организатором, начиная с 04.09.2024 00:00 и до
					официального объявления о завершении Предложения;
				</p>
				<p>
					<strong>Место проведения Предложения – </strong>Предложение проводится на сайте VIP Pass.
				</p>
				<p>
					<strong>Правила – </strong>официальные правила Предложения, опубликованные на Сайте.
				</p>
				<p>
					<strong>Участник – </strong>игрок, имеющий действующий Игровой аккаунт на ресурсе Организатора;
				</p>
				<p>
					<strong>Приз – </strong>вознаграждение, получаемое за XP в результате активности в рамках Предложения;
				</p>
				<p>
					<strong>XP – </strong>единица прогресса Участника в Игровом аккаунте, начисляемая за выполнение Квестов.
				</p>
				<p>
					<strong>FreeBet – </strong>ставка без риска, предоставляемая за счёт Организатора;
				</p>
				<p>
					<strong>FreeSpins – </strong>бесплатные вращения в выбранных казино-играх на платформе Организатора;
				</p>
				<p>
					<strong>SportBonus – </strong>денежный эквивалент, начисляемый на счёт Участника, который может быть
					использован для размещения спортивных ставок на Сайте. Бонус подлежит отыгрышу в соответствии с детальными
					бонусными правилами.
				</p>
				<p>
					<strong>Физический подарок (и Гаджеты) – </strong>материальный предмет, который Участник может получить в
					качестве Приза при выполнении условий Предложения. Физический подарок является реальным товаром, доставляемым
					или передаваемым лично по предварительному согласованию с Организатором.
				</p>
				<p>
					<strong>Инвентарь и Скины – </strong>игровые предметы платформы «Steam», получаемые Участником в качестве
					Приза. Данный Приз не может использоваться в Игровом аккаунте Организатора, поскольку является продуктом
					третьей стороны. Информация о стоимости и содержании Инвентаря или Скина указывается в условиях Приза.
				</p>
				<p>
					<strong>Квесты – </strong>набор заданий, за выполнение которых Участник получает XP, доступных в Игровом
					аккаунте;
				</p>
				<p>
					<strong>Аккаунт Steam – </strong>личный аккаунт Участника на платформе «Steam», используемый для получения
					Инвентаря и Скинов (Призов).
				</p>

				<p>
					<strong>1. Общие положения Предложения</strong>
				</p>
				<p>
					<strong>1.1. </strong>Основные положения определяют порядок, сроки, условия проведения и участия, количество
					Призов, сроки, порядок и место их получения.
				</p>
				<p>
					<strong>1.2. </strong>Организатор оставляет за собой право вносить изменения и обновлять содержание или формат
					Правил, а также исключать любой Приз из Акции в любое время без предварительного уведомления. Информация об
					изменениях публикуется на Сайте.
				</p>
				<p>
					<strong>1.3. </strong>Принимая участие в Акции, Участник подтверждает, что ознакомлен с Правилами и полностью
					согласен с ними, а также обязуется соблюдать все их условия и требования.
				</p>

				<p>
					<strong>2. Условия участия</strong>
				</p>
				<p>
					<strong>2.1. </strong>Для участия в Предложении в период проведения Акции и на условиях, предусмотренных
					Правилами, Участник обязан:
				</p>
				<p>
					<strong>2.1.1. </strong>Пройти авторизацию на Сайте, заполнить все обязательные (*) поля в личном кабинете и
					перейти в профиль «VIP Pass».
				</p>
				<p>
					<strong>2.1.2. </strong>Выполнять Квесты, доступные в период проведения Акции; ставки должны быть рассчитаны
					до окончания соответствующего периода Квеста.
				</p>
				<p>
					<strong>2.1.3. </strong>За каждый выполненный Квест Участник получает XP. XP отображаются после авторизации на
					промо-сайте и/или на Сайте. XP необходимо активировать в течение периода Квеста, нажав кнопку «Claim». Если XP
					не активированы в указанный срок, бонус становится недоступным.
				</p>

				<p>
					<strong>3. Призы и бонусы</strong>
				</p>
				<p>
					<strong>3.1. </strong>Призовой фонд формируется за счёт Организатора и включает FreeBet, FreeSpins,
					SportBonus, гаджеты, инвентарь и скины, а также фирменный мерч.
				</p>
				<p>
					<strong>3.2. </strong>При накоплении достаточного количества XP Участник может получить FreeBet, FreeSpins,
					SportBonus, гаджеты, инвентарь и скины, а также фирменную продукцию. Состав Призов, включающих предметы Steam,
					определяется согласно правилам платформы Steam на момент активации Приза и может отличаться от изображений,
					размещённых на Сайте.
				</p>
				<p>
					<strong>3.3. </strong>Состав и количество Призов, а также необходимое количество XP могут быть изменены
					Организатором в любое время без предварительного уведомления. Актуальный список Призов и условия их получения
					публикуются на Сайте.
				</p>
				<p>
					<strong>3.4. </strong>Если Приз включает предметы Steam, Участник обязан активировать его в течение 30
					(тридцати) минут с момента получения. Покупки лутбоксов, содержащих Инвентарь или Скины, возврату не подлежат.
				</p>

				<p>
					<strong>4. Условия получения физических призов</strong>
				</p>
				<p>
					<strong>4.1. </strong>Если Участник не может получить Приз лично, ответственность возлагается исключительно на
					согласованного получателя.
				</p>
				<p>
					<strong>4.2. </strong>В течение 10 дней после объявления результатов Организатор связывается с Победителями
					для организации доставки.
				</p>
				<p>
					<strong>4.3. </strong>Если Победитель не отвечает в течение 10 дней, право на получение Приза аннулируется.
				</p>
				<p>
					<strong>4.4. </strong>Результаты определения Победителей являются окончательными и обжалованию не подлежат.
				</p>
				<p>
					<strong>4.5. </strong>Призы доставляются в ближайшее почтовое отделение в течение 30 рабочих дней после
					получения контактных данных от Победителей.
				</p>
				<p>
					<strong>4.6. </strong>Организатор не несёт ответственности за дальнейшее использование Приза после его
					получения или невозможность его использования Победителем по любым причинам.
				</p>
				<p>
					<strong>4.7. </strong>Организатор не несёт ответственности за невозможность доставки Приза по причинам, не
					зависящим от него, включая некорректные или изменённые контактные данные. В таких случаях компенсация не
					предусмотрена.
				</p>

				<p>
					<strong>5. Заключительные положения</strong>
				</p>
				<p>
					<strong>5.1. </strong>Участвуя в Акции, Участник подтверждает полное понимание и принятие Правил.
				</p>
				<p>
					<strong>5.2. </strong>Организатор вправе изменять условия Акции в любое время с публикацией информации на
					Сайте.
				</p>
				<p>
					<strong>5.3. </strong>Акция доступна только для одного игрового аккаунта на одно лицо, семью, домохозяйство,
					компьютер или IP-адрес.
				</p>
				<p>
					<strong>5.4. </strong>Организатор оставляет за собой право отменить бонусы и отказать в их предоставлении без
					объяснения причин в случае подозрения на злоупотребление (мультиаккаунтинг, использование некорректных
					коэффициентов, арбитражные ставки и т.п.).
				</p>
				<p>
					<strong>5.5. </strong>Организатор вправе исключить любого Участника из Акции без объяснения причин.
				</p>
				<p>
					<strong>5.6. </strong>Настоящие условия могут быть изменены или дополнены в любое время.
				</p>
				<p>
					<strong>5.7. </strong>Общие правила VIP Pass распространяются на все промо-предложения.
				</p>
			</>
		);
	}

	if (i18n.language === 'en') {
		return (
			<>
				<p>
					VIP Pass is your unique offer from Vip House for purchasing prizes and gifts based on your gaming progress.
				</p>
				<p>
					Complete quests and earn XP, which can be exchanged for FreeSpins, FreeBet, SportBonus, limited-edition site
					merchandise, gadgets, and gaming items.
				</p>
				<p>
					The main provisions define the procedure, terms, and conditions of the Offer, participation requirements, the
					number of Prizes, as well as the сроки, порядок и место их получения.
				</p>
				<p>
					<strong>Key Terms:</strong>
				</p>
				<p>
					<strong>Offer – </strong>the promotional campaign “VIP Pass” organized by the Organizer;
				</p>
				<p>
					<strong>Organizer – </strong>(hereinafter referred to as the Site) the Vip House resource and responsible
					persons within it;
				</p>
				<p>
					<strong>Gaming Account – </strong>the personal account of the Participant registered with the Organizer;
				</p>
				<p>
					<strong>Gaming Identifier – </strong>the number of the Participant’s Gaming Account registered with the
					Organizer; Main Rules – the Organizer’s operating rules, betting and wagering rules published on the Site.
				</p>
				<p>
					<strong>Promotion Period – </strong>the time period established by the Organizer, starting from 04.09.2024
					00:00 and lasting until the official announcement of the Offer termination by the Organizer;
				</p>
				<p>
					<strong>Place of the Offer – </strong>the Offer is conducted on the VIP Pass website.
				</p>
				<p>
					<strong>Rules – </strong>the official Offer rules published on the Site.
				</p>
				<p>
					<strong>Participant – </strong>a player who has a valid Gaming Account on the Organizer’s resource;
				</p>
				<p>
					<strong>Prize – </strong>a reward received for XP as a result of activity within the Offer;
				</p>
				<p>
					<strong>XP – </strong>a unit of Participant progress in the Gaming Account earned by completing Quest(s).
				</p>
				<p>
					<strong>FreeBet – </strong>a risk-free bet provided at the Organizer’s expense;
				</p>
				<p>
					<strong>FreeSpins – </strong>free spins in selected casino games on the Organizer’s platform;
				</p>
				<p>
					<strong>SportBonus – </strong>a monetary equivalent credited to the Participant’s account that may be used for
					placing sports bets on the Site. This bonus is subject to wagering requirements specified in the detailed
					bonus rules.
				</p>
				<p>
					<strong>Physical Gift (and Gadgets) – </strong>a tangible item that the Participant may receive as a Prize
					upon fulfilling the Offer conditions. The physical gift is a real product delivered or handed over personally
					based on prior agreement with the Organizer.
				</p>
				<p>
					<strong>Inventory and Skins – </strong>gaming items from the “Steam” platform received by the Participant as a
					Prize. This Prize cannot be used within the Organizer’s Gaming Account, as it is a third-party product.
					Information about the value and content of the Inventory or Skin is specified in the Prize conditions.
				</p>
				<p>
					<strong>Quests – </strong>a set of tasks for completing which the Participant earns XP, available in the
					Gaming Account;
				</p>
				<p>
					<strong>Steam Account – </strong>the Participant’s personal account on the “Steam” platform used to receive
					Inventory and Skins (Prizes).
				</p>

				<p>
					<strong>1. General Provisions of the Offer</strong>
				</p>
				<p>
					<strong>1.1. </strong>The main provisions define the procedure, сроки, условия проведения и участия, the
					number of Prizes, сроки, порядок и место их получения.
				</p>
				<p>
					<strong>1.2. </strong>The Organizer reserves the right to amend and update the content or format of the Rules,
					as well as exclude any Prize from the Promotion at any time without prior notice. Information about amendments
					is published on the Site.
				</p>
				<p>
					<strong>1.3. </strong>By participating in the Promotion, the Participant confirms that they have read and
					fully agree with the Rules and undertake to comply with all their terms and requirements.
				</p>

				<p>
					<strong>2. Participation Conditions</strong>
				</p>
				<p>
					<strong>2.1. </strong>To participate in the Offer, during the Promotion Period and under the conditions
					provided by the Rules, the Participant must:
				</p>
				<p>
					<strong>2.1.1. </strong>Complete authorization on the Site, fill in all required (*) fields in the personal
					account, and access the “VIP Pass” profile.
				</p>
				<p>
					<strong>2.1.2. </strong>Complete the Quests available during the Promotion period; bets must be settled before
					the end of the relevant Quest period.
				</p>
				<p>
					<strong>2.1.3. </strong>For each completed Quest, the Participant receives XP. XP is displayed after
					authorization on the Promo-site and/or the Site. XP must be claimed within the Quest period by clicking the
					“Claim” button. If not claimed within the specified period, the bonus becomes unavailable.
				</p>

				<p>
					<strong>3. Prizes and Bonuses</strong>
				</p>
				<p>
					<strong>3.1. </strong>The Prize fund is formed at the Organizer’s expense and includes FreeBet, FreeSpins,
					SportBonus, gadgets, inventory and skins, and branded merchandise.
				</p>
				<p>
					<strong>3.2. </strong>Upon accumulating sufficient XP, the Participant may receive FreeBet, FreeSpins,
					SportBonus, gadgets, inventory and skins, and branded merchandise. The composition of Prizes involving Steam
					items is determined according to Steam platform rules at the moment of Prize activation and may differ from
					images displayed on the Site.
				</p>
				<p>
					<strong>3.3. </strong>The composition and number of Prizes, as well as the required XP amount, may be changed
					by the Organizer at any time without prior notice. The current list of Prizes and conditions is published on
					the Site.
				</p>
				<p>
					<strong>3.4. </strong>If a Prize involves Steam items, the Participant must activate it within 30 (thirty)
					minutes from the moment of receipt. Lootbox purchases containing Inventory or Skins are non-refundable.
				</p>

				<p>
					<strong>4. Conditions for Receiving Physical Prizes</strong>
				</p>
				<p>
					<strong>4.1. </strong>If a Participant cannot collect the Prize, responsibility remains solely with the agreed
					recipient.
				</p>
				<p>
					<strong>4.2. </strong>Within 10 days after results announcement, the Organizer will contact Winners to arrange
					delivery.
				</p>
				<p>
					<strong>4.3. </strong>If the Winner does not respond within 10 days, the right to receive the Prize is
					forfeited.
				</p>
				<p>
					<strong>4.4. </strong>The results of Winner determination are final and not subject to appeal.
				</p>
				<p>
					<strong>4.5. </strong>Prizes will be delivered to the nearest postal office within 30 business days after
					receiving contact details from Winners.
				</p>
				<p>
					<strong>4.6. </strong>The Organizer is not responsible for how the Prize is used after receipt or if the
					Winner is unable to use it for any reason.
				</p>
				<p>
					<strong>4.7. </strong>The Organizer is not responsible for inability to deliver a Prize due to reasons beyond
					its control, including incorrect or changed contact details. No compensation is provided in such cases.
				</p>

				<p>
					<strong>5. Final Provisions</strong>
				</p>
				<p>
					<strong>5.1. </strong>By participating, the Participant confirms full understanding and acceptance of the
					Rules.
				</p>
				<p>
					<strong>5.2. </strong>The Organizer may amend the Promotion terms at any time, with information published on
					the Site.
				</p>
				<p>
					<strong>5.3. </strong>The Promotion is available for only one gaming account per person, family, household,
					computer, or IP address.
				</p>
				<p>
					<strong>5.4. </strong>The Organizer reserves the right to cancel bonuses and refuse provision without
					explanation in case of suspected abuse (multi-accounting, incorrect odds exploitation, arbitrage betting,
					etc.).
				</p>
				<p>
					<strong>5.5. </strong>The Organizer may exclude any Participant from the Promotion without explanation.
				</p>
				<p>
					<strong>5.6. </strong>These terms may be amended or supplemented at any time.
				</p>
				<p>
					<strong>5.7. </strong>General VIP Pass rules apply to all promotional offers.
				</p>
			</>
		);
	}
	return (
		<>
			<p>VIP Pass – твоя унікальна пропозиція від Vip House з купівлі призів та подарунків за ігровий прогрес.</p>
			<p>
				Виконуй квести та отримуй XP, які можна обміняти на FreeSpins, FreeBet, SportBonus, лімітований мерч сайту,
				гаджети та ігрові матеріали.
			</p>
			<p>
				Основні положення визначають порядок, терміни, умови проведення та участі в Пропозиції, кількість Призів,
				строки, порядок та місце їх отримання.
			</p>
			<p>
				<strong>Основні терміни:</strong>
			</p>
			<p>
				<strong>Пропозиція - </strong>акція &quot;VIP Pass&quot;, яка проводиться Організатором;
			</p>
			<p>
				<strong>Організатор - </strong>(далі Сайт) ресурс Vip House та відповідальні особи у його складі;
			</p>
			<p>
				<strong>Ігровий аккаунт – </strong>особистий обліковий запис Учасника, зареєстрований в Організатора;
			</p>
			<p>
				<strong>Ігровий ідентифікатор – </strong>номер Ігрового аккаунта Учасника, який зареєстрований в Організатора;
				​​Основні правила – правила роботи, прийому ставок та парі Організатора, які розміщуються на Сайті.
			</p>
			<p>
				<strong>Термін проведення – </strong>часовий проміжок встановлений Організатором, який починається 04.09.2024
				00:00 і триватиме до офіційного інформування Організатором про завершення Пропозиції;
			</p>
			<p>
				<strong>Місце проведення Пропозиції – </strong>Пропозиція проводиться на Сайті VIP Pass.
			</p>
			<p>
				<strong>Правила – </strong>офіційні правила Пропозиції, що розміщуються на Сайті.
			</p>
			<p>
				<strong>Учасник – </strong>гравець, який має валідний Ігровий аккаунт на ресурсі Організатора;
			</p>
			<p>
				<strong>Приз – </strong>виграш отриманий за XP в результаті активності в Пропозиції;
			</p>
			<p>
				<strong>XP – </strong>одиниця прогресу Учасника на Ігровому акаунті, отриманого в результаті виконання умов
				Квесту-(ів).
			</p>
			<p>
				<strong>FreeBet – </strong>ставка без ризику за рахунок Організатора;
			</p>
			<p>
				<strong>FreeSpins – </strong>безкоштовні прокрути у тій чи іншій грі казино на ресурсі Організатора;
			</p>
			<p>
				<strong>SportBonus – </strong>грошовий єквівалент на аккаунті Учасника, який може бути використаний на Сайті для
				формування спортивних ставок. Цей бонус потребує відіграш та ці умови будуть зазначені в детальних правилах
				отриманного бонусу.
			</p>
			<p>
				<strong>Фізичний подарунок (та Гаджети) – </strong>матеріальний предмет, який Учасник може отримати у виді Приза
				в разі виконання умов Пропозиції. Фізичний подарунок є реальним товаром, який буде доставлено або вручено
				особисто на підставі попередніх домовленостей з Організатором.
			</p>
			<p>
				<strong>Інвентар та Скіни – </strong>ігровий продукт платформи &quot;Steam&quot; отриманий Учасником у виді
				Приза. Даний Приз не може бути використаним в Ігровому акаунті в Організатора, так як є стороннім продуктом.
				Інформація про вартість та зміст Інвентаря або Скіна зазначена в умовах Призу.
			</p>
			<p>
				<strong>Квести – </strong>підбірка завдань, за виконання яких Учасник отримує XP, доступні на Ігровому аккаунті;
			</p>
			<p>
				<strong>Обліковий запис Steam – </strong>особистий обліковий запис Учасника на ресурсі &quot;Steam&quot;, який
				буде застосований для отримання Інвентаря та Скінів (Призів).
			</p>

			<p>
				<strong>1. Основні положення Пропозиції</strong>
			</p>
			<p>
				<strong>1.1. </strong>Основні положення визначають порядок, терміни, умови проведення та участі в Пропозиції,
				кількість Призів, строки, порядок та місце їх отримання.
			</p>
			<p>
				<strong>1.2. </strong>Організатор залишає за собою право вносити зміни та оновлювати зміст або формат Правил, а
				також виключати будь-який із Призів з розіграшу в Акції у будь-який час без попереднього повідомлення.
				Інформація про внесені зміни розміщується Організатором на Сайті.
			</p>
			<p>
				<strong>1.3. </strong>Беручи участь в Акції, Учасник підтверджує ознайомлення та повну згоду з Правилами, та
				прийняття на себе зобов&apos;язання дотримуватись усіх їхніх умов та вимог.
			</p>

			<p>
				<strong>2. Умови участі в Пропозиції</strong>
			</p>
			<p>
				<strong>2.1. </strong>Для участі в Пропозиції, Учасник протягом Терміну проведення Пропозиції на умовах,
				передбачених Правилами, повинен:
			</p>
			<p>
				<strong>2.1.1. </strong>Пройти процедуру авторизації на Сайті, заповнити всі поля зазначені * в особистому
				кабінеті на Сайті, перейти до профілю в &quot;VIP Pass&quot;.
			</p>
			<p>
				<strong>2.1.2. </strong>Виконувати Квести, які доступні у період дії акції; ставки мають бути розраховані до
				завершення Квесту поточного періоду.
			</p>
			<p>
				<strong>2.1.3. </strong>За кожен виконаний Квест Учасник отримує XP. XP відображаються після авторизації
				Учасника на Промо-сайті та/або Сайті. XP необхідно забрати в період дії Квесту, за який він отримано, натиснувши
				кнопку «Отримати». Якщо бонус не буде забраний у період, зазначений у цьому пункті, він стає недоступним.
			</p>

			<p>
				<strong>3. Призи та Бонуси</strong>
			</p>
			<p>
				<strong>3.1. </strong>Призовий фонд Пропозиції формується за кошти Організатора та складається з FreeBet,
				FreeSpins, Sportbonus, гаджетів, інвентаря та скінів, фірмового мерчу.
			</p>
			<p>
				<strong>3.2. </strong>В якості Приза Учасником, при накопиченні достатньої кількості XP можуть бути отримані
				FreeBet, FreeSpins, Sportbonus, гаджети, інвентар та скіни, фірмовий мерч. Склад Призів, що передбачають
				отримання предметів на акаунті Steam, визначається відповідно до правил платформи Steam на момент активації
				Приза і може відрізнятися від зображень на Сайті
			</p>
			<p>
				<strong>3.3. </strong>Склад і кількість Призів, що беруть участь в Пропозиції, а також кількість XP, необхідних
				для отримання Приза, можуть змінюватися Організатором у будь-який час без попереднього повідомлення. Актуальний
				список Призів та умови їх отримання розміщуються Організатором на Сайті.
			</p>
			<p>
				<strong>3.4. </strong>У разі вибору в якості Приза будь-якого предмета або комплекту предметів, які мають бути
				зараховані через акаунт Steam, Учасник повинен активувати отриманий Приз протягом 30 (Тридцяти) хвилин з моменту
				його отримання. При покупці лутбоксу з Інвентарем або Скіном всередині відміна покупки неможлива.
			</p>

			<p>
				<strong>4. Умови отримання фізичних призів</strong>
			</p>
			<p>
				<strong>4.1. </strong>Якщо Учасник акції не може забрати приз, подальша відповідальність за отримання Приза
				залишається виключно за домовленним сторонами отримувачем.
			</p>
			<p>
				<strong>4.2. </strong>Протягом 10 днів з моменту оголошення результатів Організатор зв&apos;яжеться з
				Переможцями, які отримали право на отримання призу, та погодить умови доставки виграного призу.
			</p>
			<p>
				<strong>4.3. </strong>Якщо Переможець не вийде на зв&apos;язок з Організатором протягом 10 днів після звернення,
				такий учасник акції втрачає право на отримання призу.
			</p>
			<p>
				<strong>4.4. </strong>Результати визначення Переможців остаточні та оскарженню не підлягають.
			</p>
			<p>
				<strong>4.5. </strong>Доставка призів буде здійснена на найближче відділення пошти протягом 30 робочих днів з
				моменту отримання контактних даних клієнтів, що перемогли в акції.
			</p>
			<p>
				<strong>4.6. </strong>Організатор не несе відповідальності за використання переможцем призу після його отримання
				та/або неможливість Переможцем скористатися наданим призом з будь-якої причини.
			</p>
			<p>
				<strong>4.7. </strong>Організатор не несе відповідальності за неможливість отримання призу Переможцем з
				будь-яких причин, що не залежать від Компанії, у тому числі: якщо контактна адреса, ім&apos;я та/або прізвище
				або інші необхідні дані були вказані неправильно, змінені тощо. При цьому такий Переможець не має права на
				компенсацію від Компанії.
			</p>

			<p>
				<strong>5. Заключні положення</strong>
			</p>
			<p>
				<strong>5.1. </strong>Своєю участю в Акції, Учасник підтверджує, що ознайомлений з Правилами, їх зміст та умови
				йому зрозумілі, він з ними повністю згоден і зобов&apos;язується їх дотримуватися.
			</p>
			<p>
				<strong>5.2. </strong>Організатор має право в будь-який час в односторонньому порядку змінювати умови та правила
				проведення Акції, інформація про це розміщується Організатором на Сайті.
			</p>
			<p>
				<strong>5.3. </strong>Акція доступна лише для одного ігрового рахунку на людину, сім&apos;ю, квартиру,
				комп&apos;ютер чи IP-адресу.
			</p>
			<p>
				<strong>5.4. </strong>Організатор залишає за собою право анулювати бонус та відмовити Учаснику у його наданні
				без пояснення причин у разі, якщо під час перевірки облікового запису Учасника виникнуть підозри у порушенні
				чесності гри або застосуванні стратегій, які компанія на свій розсуд вважає зловмисними (мультіакаунтинг, гра за
				некоректними коефіцієнтами, арбітражним ситуаціям тощо.).
			</p>
			<p>
				<strong>5.5. </strong>Організатор залишає за собою право виключити будь-якого Учасника з Акції та розіграшу без
				пояснення причин.
			</p>
			<p>
				<strong>5.6. </strong>Ці умови можуть бути змінені та доповнені як у період проведення акції, так і у будь-який
				час.
			</p>
			<p>
				<strong>5.7. </strong>У правилах акційних пропозицій діють загальні правила VIP Pass
			</p>
		</>
	);
};
